import {
    SCORE_BOMB_CARD,
    SCORE_CONNECTED_CARD,
    SCORE_FOG_CARD,
    SCORE_ICE_CARD,
    SCORE_LOWERING_CARD,
    SCORE_PICKAXE_CARD,
    SCORE_RISING_CARD,
    SCORE_ROPE_CARD,
    SCORE_TNT_MODIFIER,
} from 'Constants/Score';
import { CardModifierType } from './CardModifierType';

export const ModifierScoreMap: Partial<Record<CardModifierType, number>> = {
    [CardModifierType.bomb]: SCORE_BOMB_CARD,
    [CardModifierType.connected]: SCORE_CONNECTED_CARD,
    [CardModifierType.fog]: SCORE_FOG_CARD,
    [CardModifierType.ice]: SCORE_ICE_CARD,
    [CardModifierType.lowering]: SCORE_LOWERING_CARD,
    [CardModifierType.pickaxe]: SCORE_PICKAXE_CARD,
    [CardModifierType.rising]: SCORE_RISING_CARD,
    [CardModifierType.rope]: SCORE_ROPE_CARD,
    [CardModifierType.tnt]: SCORE_TNT_MODIFIER,
};
